import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_strategic_portfolio.webp';
import "../solution.css"
const StrategicPortfolio = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white w-full sm:w-full md:w-2/3 lg:w-[732px]">
                        Adapt Quickly to Changing Circumstances
                    </h1>
                    <p className="text-white text-sm w-full md:w-2/3 lg:w-[635px]" data-aos="fade-down">
                        Tekpossible is your go-to partner for leveraging ServiceNow SPM to drive operational agility. Our expertise helps your business align strategic goals with execution, enabling you to deliver impactful results, even in the face of challenges.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>


            <div className="bg-[#FFFFFF] mt-6 mb-10">
                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-2xl lg:text-3xl">
                        What can we help you achieve with SPM solutions by ServiceNow?
                    </h1>
                </div>

                <div className="bg-white">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 px-4 md:px-10 lg:px-10 py-5">

                        <div className="flex flex-col items-center text-center lined_hoverset">
                            <h2 className="text-[#000] text-base md:text-lg lg:text-xl font-semibold max-w-[253px]">
                                Focus on the Right Things
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-full md:w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[352px]">
                                Develop flexible and dynamic plans that clearly outline strategies and objectives, while incorporating real-time updates on roadmaps to enable agile and informed decision-making.
                            </p>
                        </div>

                        <div className="flex flex-col items-center text-center lined_hoverset">
                            <h2 className="text-[#000] text-base md:text-lg lg:text-xl font-semibold max-w-[253px]">
                                Respond to Change Quickly
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-full md:w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[352px]">
                                Equip planners and managers with tools to track tasks, initiatives, and team dependencies, enabling them to prioritize work effectively and align efforts with strategic goals.
                            </p>
                        </div>

                        <div className="flex flex-col items-center text-center lined_hoverset">
                            <h2 className="text-[#000] text-base md:text-lg lg:text-xl font-semibold max-w-[200px]">
                                Enable Flexible Ways of Work
                            </h2>
                            <div className="mt-2 flex flex-col items-center w-full md:w-40">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-black text-sm md:text-base max-w-[352px]">
                                Ensure the capacity to fund, govern, and oversee all initiatives, while empowering teams to adopt their preferred work methodologies and organizational structures as necessary.
                            </p>
                        </div>
                    </div>
                </div>
            </div>


            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-down" data-aos-duration="1000" className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow SPM Expertise
                    </h1>

                    <h5 data-aos="fade-up" data-aos-duration="1000" className="text-md text-black font-medium text-center max-w-[1000px]">
                        Application Portfolio Management | Scrum & Scaled Agile Framework | Project & Portfolio Management | Investment Funding
                        Demand Management | Innovation Management | Release Management | Resource Management | Timecards
                    </h5>
                </div>
            </div>


            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-up" data-aos-duration="1000" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/2 lg:w-2/3">
                        Ready to supercharge your ServiceNow SPM solutions?
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default StrategicPortfolio;